export default [{
  _name: 'CSidebarNav',
  _children: [{
      _name: 'CSidebarNavItem',
      name: 'Dashboard',
      to: '/dashboard',
      icon: 'cil-speedometer',
    },
    {
      _name: 'CSidebarNavItem',
      name: 'HeatMap',
      to: '/heatmap',
      icon: 'cil-speedometer',
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Produk',
      route: '/product',
      icon: 'cil-line-weight',
      items: [{
          name: 'Kategori',
          to: '/product/category'
        },
        {
          name: 'Brand',
          to: '/product/brand'
        },
        {
          name: 'Produk Katalog',
          to: '/product/catalog'
        },
        {
          name: 'Product Katalog (pending)',
          to: '/product/catalog-pending'
        },
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Outlet',
      route: '/outlet',
      icon: 'cil-lan',
      items: [{
          name: 'List',
          to: "/outlet"
        },
        {
          name: 'Detail',
          to: "/outlet/-"
        },
        {
          name: 'Product',
          to: "/outlet/-/prod"
        },
        {
          name: 'Transaction',
          to: "/outlet/-/transaction"
        },
      ],
    },
    {
      _name: 'CSidebarNavItem',
      name: 'User',
      to: '/user',
      icon: 'cil-group',
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Home Slider',
      to: '/slider',
      icon: 'cil-image',
    },
    {
      _name: 'CSidebarNavItem',
      name: 'FAQ',
      to: '/faq',
      icon: 'cil-align-left',
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Release Version',
      to: '/faq',
      icon: 'cil-align-left',
    },
  ]
}]